import React from 'react';
import { Platform, View, StyleSheet } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import { Provider as PaperProvider, MD3LightTheme } from 'react-native-paper';
import { NavigationContainer } from '@react-navigation/native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { FirebaseAuthProvider } from './context/FirebaseAuthContext';
import { FirebaseTripsProvider } from './context/FirebaseTripsContext';
import RootNavigator from './navigation/RootNavigator';
import { theme } from './constants/theme';
import { useNotifications } from './hooks/useNotifications';
import ErrorBoundary from './components/ErrorBoundary';
import * as Linking from 'expo-linking';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';

const prefix = Linking.createURL('/');

const linking = {
  prefixes: [prefix],
  config: {
    screens: {
      Main: {
        screens: {
          Trips: 'trips',
          AddTrip: 'add',
          Settings: 'settings',
          Inbox: 'inbox',
        },
      },
      TripDetail: 'trip/:tripId',
      Auth: 'auth',
    },
  },
};

const appTheme = {
  ...MD3LightTheme,
  ...theme,
};

// Configure icon component for web
const settings = Platform.OS === 'web' 
  ? {
      icon: (props: any) => <MaterialCommunityIcons {...props} />
    }
  : {};

export default function App() {
  // Only initialize notifications on native platforms
  if (Platform.OS !== 'web') {
    useNotifications();
  }

  const AppContent = (
    <PaperProvider theme={appTheme} settings={settings}>
      <FirebaseAuthProvider>
        <FirebaseTripsProvider>
          <NavigationContainer linking={linking}>
            <RootNavigator />
            <StatusBar style="auto" />
          </NavigationContainer>
        </FirebaseTripsProvider>
      </FirebaseAuthProvider>
    </PaperProvider>
  );

  if (Platform.OS === 'web') {
    return (
      <ErrorBoundary>
        <View style={styles.webContainer}>
          {AppContent}
        </View>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <SafeAreaProvider>
        {AppContent}
      </SafeAreaProvider>
    </ErrorBoundary>
  );
}

const styles = StyleSheet.create({
  webContainer: {
    flex: 1,
    height: '100vh',
    width: '100%',
  },
});
